"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pathJoin = pathJoin;
exports.getRoutePath = getRoutePath;
exports.getCurrentRoutePath = getCurrentRoutePath;
exports.unwrapArray = unwrapArray;
exports.isObject = isObject;
exports.deprecate = deprecate;
exports.removal = removal;
exports.isAbsoluteUrl = isAbsoluteUrl;
exports.makePathAbsolute = makePathAbsolute;
exports.reduceHooks = reduceHooks;
exports.mapHooks = mapHooks;
exports.getHooks = getHooks;
exports.getFullRouteData = getFullRouteData;
exports.is404Path = is404Path;
Object.defineProperty(exports, "poolAll", {
  enumerable: true,
  get: function get() {
    return _swimmer.poolAll;
  }
});
Object.defineProperty(exports, "createPool", {
  enumerable: true,
  get: function get() {
    return _swimmer.createPool;
  }
});
exports.PATH_404 = exports.cleanSlashes = exports.trimDoubleSlashes = exports.trimTrailingSlashes = exports.trimLeadingSlashes = exports.cutPathToRoot = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _swimmer = require("swimmer");
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var REGEX_TO_CUT_TO_ROOT = /(\..+?)\/.*/g;
var REGEX_TO_REMOVE_LEADING_SLASH = /^\/{1,}/g;
var REGEX_TO_REMOVE_TRAILING_SLASH = /\/{1,}$/g;
var REGEX_TO_REMOVE_DOUBLE_SLASH = /\/{2,}/g;
var cutPathToRoot = function cutPathToRoot() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return string.replace(REGEX_TO_CUT_TO_ROOT, '$1');
};
exports.cutPathToRoot = cutPathToRoot;
var trimLeadingSlashes = function trimLeadingSlashes() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return string.replace(REGEX_TO_REMOVE_LEADING_SLASH, '');
};
exports.trimLeadingSlashes = trimLeadingSlashes;
var trimTrailingSlashes = function trimTrailingSlashes() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return string.replace(REGEX_TO_REMOVE_TRAILING_SLASH, '');
};
exports.trimTrailingSlashes = trimTrailingSlashes;
var trimDoubleSlashes = function trimDoubleSlashes() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (isAbsoluteUrl(string)) {
    var _string$split = string.split('://'),
      _string$split2 = (0, _slicedToArray2["default"])(_string$split, 2),
      _string$split2$ = _string$split2[0],
      scheme = _string$split2$ === void 0 ? '' : _string$split2$,
      _string$split2$2 = _string$split2[1],
      path = _string$split2$2 === void 0 ? '' : _string$split2$2;
    return [scheme, path.replace(REGEX_TO_REMOVE_DOUBLE_SLASH, '/')].join('://');
  }
  return string.replace(REGEX_TO_REMOVE_DOUBLE_SLASH, '/');
};
exports.trimDoubleSlashes = trimDoubleSlashes;
var cleanSlashes = function cleanSlashes(string) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!string) return '';
  var _options$leading = options.leading,
    leading = _options$leading === void 0 ? true : _options$leading,
    _options$trailing = options.trailing,
    trailing = _options$trailing === void 0 ? true : _options$trailing,
    _options$double = options["double"],
    _double = _options$double === void 0 ? true : _options$double;
  var cleanedString = string;
  if (leading) {
    cleanedString = trimLeadingSlashes(cleanedString);
  }
  if (trailing) {
    cleanedString = trimTrailingSlashes(cleanedString);
  }
  if (_double) {
    cleanedString = trimDoubleSlashes(cleanedString);
  }
  return cleanedString;
};
exports.cleanSlashes = cleanSlashes;
function pathJoin() {
  for (var _len = arguments.length, paths = new Array(_len), _key = 0; _key < _len; _key++) {
    paths[_key] = arguments[_key];
  }
  var newPath = paths.map(cleanSlashes).join('/');
  if (!newPath || newPath === '/') {
    return '/';
  }
  newPath = cleanSlashes(newPath);
  if (newPath.includes('?')) {
    newPath = newPath.substring(0, newPath.indexOf('?'));
  }
  return newPath;
} // This function is for extracting a routePath from a path or string
// RoutePaths do not have query params, basePaths, and should
// resemble the same string as passed in the static.config.js routes

function getRoutePath(routePath) {
  // Detect falsey paths and the root path
  if (!routePath || routePath === '/' || routePath === process.env.REACT_STATIC_BASE_PATH) {
    return '/';
  } // Remove origin, hashes, and query params

  if (typeof document !== 'undefined') {
    routePath = routePath.replace(window.location.origin, '');
    routePath = routePath.replace(/#.*/, '');
    routePath = routePath.replace(/\?.*/, '');
  } // Be sure to remove the base path

  if (process.env.REACT_STATIC_BASE_PATH) {
    routePath = routePath.replace(new RegExp("^\\/?".concat(process.env.REACT_STATIC_BASE_PATH, "(\\/|$)")), '');
  }
  routePath = routePath || '/';
  return pathJoin(routePath);
}
function getCurrentRoutePath() {
  // If in the browser, use the window
  if (typeof document !== 'undefined') {
    return getRoutePath(decodeURIComponent(window.location.href));
  }
}
function unwrapArray(arg, defaultValue) {
  arg = Array.isArray(arg) ? arg[0] : arg;
  if (!arg && defaultValue) {
    return defaultValue;
  }
  return arg;
}
function isObject(a) {
  return !Array.isArray(a) && (0, _typeof2["default"])(a) === 'object' && a !== null;
}
function deprecate(from, to) {
  console.warn("React-Static deprecation notice: ".concat(from, " will be deprecated in favor of ").concat(to, " in the next major release."));
}
function removal(from) {
  console.warn("React-Static removal notice: ".concat(from, " is no longer supported in this version of React-Static. Please refer to the CHANGELOG for details."));
}
function isAbsoluteUrl(url) {
  if (typeof url !== 'string') {
    return false;
  }
  return /^[a-z][a-z0-9+.-]*:/.test(url);
}
function makePathAbsolute(path) {
  if (typeof path !== 'string') {
    return '/';
  }
  if (isAbsoluteUrl(path)) {
    return path;
  }
  return "/".concat(trimLeadingSlashes(path));
}
function reduceHooks(hooks) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    sync = _ref.sync;

  // These returns a runner that takes a value (and options) and
  // reduces the value through each hook, returning the
  // final value
  // compare is a function which is used to compare
  // the prev and next value and decide which to use.
  // By default, if undefined is returned from a reducer, the prev value
  // is retained
  // If synchronous, things are simple
  if (sync) {
    return function (value, options) {
      return hooks.reduce(function (prev, hook) {
        var next = hook(prev, options);
        if (next instanceof Promise) {
          throw new Error('Expected hook to return a value, but received promise instead. A plugin is attempting to use a sync plugin with an async function!');
        }
        return typeof next !== 'undefined' ? next : prev;
      }, value);
    };
  } // We create a map of hook handlers that point to the next hook
  // in line and reduce the value throughout (or return it if it's done)

  return function (startValue, options) {
    var hookList = hooks.map(function (hook, index) {
      return /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(lastValue) {
          var nextValue;
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return hook(lastValue, options);
                case 2:
                  nextValue = _context.sent;
                  nextValue = typeof nextValue !== 'undefined' ? nextValue : lastValue;
                  if (!hookList[index + 1]) {
                    _context.next = 6;
                    break;
                  }
                  return _context.abrupt("return", hookList[index + 1](nextValue));
                case 6:
                  return _context.abrupt("return", nextValue);
                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }();
    });
    return hookList.length ? hookList[0](startValue) : startValue;
  };
}
function mapHooks(hooks) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    sync = _ref3.sync;

  // Returns a function that takes state and returns
  // a flat array of values mapped from each hook
  if (sync) {
    return function (state) {
      var results = hooks.map(function (hook) {
        return hook(state);
      });
      return results.filter(function (d) {
        return typeof d !== 'undefined';
      });
    };
  }
  return function (state) {
    var results = [];
    var hookList = hooks.map(function (hook, index) {
      return /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return hook(state);
              case 2:
                results[index] = _context2.sent;
                if (!hookList[index + 1]) {
                  _context2.next = 5;
                  break;
                }
                return _context2.abrupt("return", hookList[index + 1]());
              case 5:
                return _context2.abrupt("return", results.filter(function (d) {
                  return typeof d !== 'undefined';
                }));
              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    });
    return hookList.length ? hookList[0]() : [];
  };
}
function getHooks(plugins, hook) {
  if (!hook) {
    throw new Error('A hook ID is required!');
  } // The flat hooks

  var hooks = []; // Adds a plugin hook to the hook list

  var addToHooks = function addToHooks(plugin) {
    // Add the hook
    hooks.push(plugin.hooks[hook]); // Recurse into sub plugins if needs be

    if (plugin.plugins) {
      plugin.plugins.forEach(addToHooks);
    }
  }; // Start with the config plugins

  plugins.forEach(addToHooks); // Filter out falsey entries

  return hooks.filter(Boolean);
}
function getFullRouteData(routeInfo) {
  return _objectSpread(_objectSpread({}, routeInfo.sharedData ? routeInfo.sharedData : {}), routeInfo.data);
}
var PATH_404 = '404';
exports.PATH_404 = PATH_404;
function is404Path(path) {
  return path === PATH_404;
}